import { apiSlice } from "../app/api/apiSlice";

export const ticketsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserReceipts: builder.query({
            query: ({user_id,search,pagination,start_date,end_date,status,employee_id}) => `user/user-receipts/${user_id}/${search}/${pagination}/${start_date}/${end_date}/${status}/${employee_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['Ticket']
        }),

        getAllUserReceipts: builder.mutation({
            query: ({user_id,pagination}) => `user/user-receipts/${user_id}/${pagination}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['Ticket']
        }),

        getUserReceiptsOrSearchWithRangeANDOREmployeeId: builder.mutation({
            query: ({user_id,search,pagination,start_date,end_date,status,employee_id}) => `user/user-receipts/${user_id}/${search}/${pagination}/${start_date}/${end_date}/${status}/${employee_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['Ticket']
        }),

        getUserReceiptsSearch: builder.mutation({
            query: ({user_id,search,pagination,start_date,end_date,status,employee_id}) => `user/user-receipts/${user_id}/${search}/${pagination}/${start_date}/${end_date}/${status}/${employee_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['Ticket']
        }),

        getUserReceiptsPageChange: builder.mutation({
            query: ({user_id,search,pagination,start_date,end_date,status,employee_id,page}) => `user/user-receipts/${user_id}/${search}/${pagination}/${start_date}/${end_date}/${status}/${employee_id}?page=${page}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['Ticket']
        }),

        getReceiptById: builder.mutation({
            query: (id) => `user/receipt/${id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['Ticket']
        }),
        userReceiptSettings: builder.mutation({
            query: (input) => ({
                url: `user/user-receipt-settings`,
                method: 'POST',
                body: { ...input }
            }),
            invalidatesTags: ['UserReceiptSettings']
        }),
        getUserReceiptSettings: builder.query({
            query: (user_id) => `user/receipt-settings/${user_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['UserReceiptSettings']
        }),
        deleteUserLogo: builder.mutation({
            query: (user_id) => ({
                url: `user/delete-user-logo/${user_id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['UserReceiptSettings']
        }),
        //Ticket verification
        qrcodeReceiptVerificaton: builder.query({
            query: (tn_number) => `user/ticket/${tn_number}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['UserReceiptSettings']
        }),

        






        getSystemRoles: builder.query({
            query: () => '/user/roles',
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['Ticket']
        }),
        getAvailableSeats: builder.query({
            query: ({client_id,client_route_id,time_id,date}) => `user/available-seats/${client_id}/${client_route_id}/${time_id}/${date}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['Ticket']
        }),
        getAvailableSeatsForPostponTicket: builder.mutation({
            query: (reqBoby) => ({
                url: `user/get-available-seats-for-postpon-ticket`,
                method: 'POST',
                body: reqBoby
            }),
            invalidatesTags: ['Ticket']
        }),
        postponTicket: builder.mutation({
            query: (reqBoby) => ({
                url: `user/postpon-ticket`,
                method: 'POST',
                body: reqBoby
            }),
            invalidatesTags: ['Ticket']
        }),
        processTicketInfo: builder.mutation({
            query: (reqBoby) => ({
                url: `user/process-ticket-info`,
                method: 'POST',
                body: reqBoby
            }),
            invalidatesTags: ['Ticket']
        }),
        ProcessPhysicalTicketData: builder.mutation({
            query: (reqBoby) => ({
                url: `user/process-physical-ticket-info`,
                method: 'POST',
                body: reqBoby
            }),
            invalidatesTags: ['Ticket']
        }),
        reservePhysicalTicketData: builder.mutation({
            query: (reqBoby) => ({
                url: `user/reserve-physical-ticket`,
                method: 'POST',
                body: reqBoby
            }),
            invalidatesTags: ['Ticket']
        }),
        processPurchaseTicketSuccessful: builder.mutation({
            query: (reqBoby) => ({
                url: `user/process-purchase-ticket-succesful`,
                method: 'POST',
                body: reqBoby
            }),
            invalidatesTags: ['Ticket']
        }),
        ticketVerification: builder.mutation({
            query: (reqBoby) => ({
                url: `/user/ticket-verification`,
                method: 'POST',
                body: reqBoby
            }),
            invalidatesTags: ['Ticket']
        }),
    })
})

export const {
    useGetUserReceiptsQuery,
    useGetUserReceiptsSearchMutation,
    useGetUserReceiptsPageChangeMutation,
    useGetUserReceiptsOrSearchWithRangeANDOREmployeeIdMutation,
    useGetAllUserReceiptsMutation,
    useUserReceiptSettingsMutation,
    useGetUserReceiptSettingsQuery,
    useQrcodeReceiptVerificatonQuery,
    useDeleteUserLogoMutation,
    


    
    useProcessTicketInfoMutation,
    useGetAvailableSeatsQuery,
    usePostponTicketMutation,
    useProcessPurchaseTicketSuccessfulMutation,
    useGetAvailableSeatsForPostponTicketMutation,
    useProcessPhysicalTicketDataMutation,
    useReservePhysicalTicketDataMutation,
    useTicketVerificationMutation,
} = ticketsApiSlice

